import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { OverlappingFeatureAction } from 'features/mapping/mapping.types';
import { usePoisState } from 'state/usePoisState';
import { useMapDrawerEntityForPoiState } from 'state/useMapDrawerEntityForPoiState';
import { useMapEntityDrawer } from 'features/mapping/hooks/useMapEntityDrawer';
import { resetRouterEntitySelection } from 'features/mapping/utils/resetRouterEntitySelection';

type UseActivateOverlappingFeature = {
  activateFeature: (action: OverlappingFeatureAction) => void;
};

export const useActivateOverlappingFeature =
  (): UseActivateOverlappingFeature => {
    const history = useHistory();
    const { setSelectedPois, clearSelectedPois } = usePoisState();
    const { setMapDrawerEntityForPoi } = useMapDrawerEntityForPoiState();
    const { minimizeEntityDrawer, restoreEntityDrawer } = useMapEntityDrawer();

    const activateFeature = useCallback(
      (action: OverlappingFeatureAction) => {
        switch (action.category) {
          case 'routerEntity':
            clearSelectedPois();
            setMapDrawerEntityForPoi(null);
            history.push(action.path);
            restoreEntityDrawer();
            break;

          case 'poi':
            setMapDrawerEntityForPoi(null);
            resetRouterEntitySelection(history);
            setSelectedPois([action.poi]);
            minimizeEntityDrawer();
            break;

          case 'drawerEntityPoi':
            clearSelectedPois();
            setMapDrawerEntityForPoi([action.entity]);
            break;

          default:
            break;
        }
      },
      [
        history,
        clearSelectedPois,
        setSelectedPois,
        setMapDrawerEntityForPoi,
        minimizeEntityDrawer,
        restoreEntityDrawer,
      ],
    );

    return { activateFeature };
  };
